import { useState } from "react";
import { useHistory } from "react-router-dom";

import { useFirebase } from "@meddbriefer/mdb-firebase";
import { verifyDocNameUniqueness } from "@meddbriefer/scenario-data";

const COLLECTION_ID = "class_codes";

export default function NewClassCode() {
  const { db } = useFirebase();
  const [name, setName] = useState("");
  const [error, setError] = useState(null);
  const history = useHistory();

  const handleChange = (event) => {
    setName(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ("" === name) {
      setError("Please enter a name for this class code");
      return;
    }
    const isUnique = await verifyDocNameUniqueness(
      db,
      COLLECTION_ID,
      name,
      "name",
      "V2"
    );
    if (!isUnique) {
      setError("Class code must be unique");
      return;
    }
    setError(null);
    const docRef = db.collection("class-codes").doc();
    await docRef.set({
      id: docRef.id,
      name: name,
      assignments: [],
      orderRequired: false,
      schemaVersion: "V2",
    });
    // alert(`created ${name}`)
    history.push(`/class-codes/${docRef.id}`);
  };

  return (
    <>
      <h1>Create Class Code</h1>
      <label>
        Title
        <input type="text" value={name} onChange={handleChange} />
      </label>
      <button type="button" onClick={handleSubmit}>
        Submit
      </button>
      <div className={error ? "" : "hidden"}>{error}</div>
    </>
  );
}
